import { IDispatcherService, IDispatcher } from '../';
import { ITrigger } from '../../models';
import { ITriggerActionsService } from './triggers.actionCreator';

export interface ITriggerStoreService {
    getAll: (force?: boolean) => angular.IPromise<ITrigger[]>;
    addOne: (trigger: ITrigger) => angular.IPromise<ITrigger>;
    updateOne: (trigger: ITrigger) => angular.IPromise<ITrigger>;
    deleteOne: (guid: string) => angular.IPromise<ITrigger>;
}

export interface ITriggerActionDispatcherService extends IDispatcherService<ITriggerStoreService> { }

export class TriggerActionDispatcherService implements ITriggerActionDispatcherService {
    static serviceId = 'triggerActionDispatcherService';

    static $inject = ['triggerActionsService'];

    constructor(private _service: ITriggerActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITriggerStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._service.getAll(force)),
                addOne: (trigger: ITrigger) => dispatch(this._service.addOne(trigger)),
                updateOne: (trigger: ITrigger) => dispatch(this._service.updateOne(trigger)),
                deleteOne: (guid: string) => dispatch(this._service.deleteOne(guid))
            }
        };
    }
}
